/*
 *@Description: 数据适配器
 *@Author: zhengff
 *@Date: 2019-05-02 17:13:28
*/

const DATA = {
  /*
   *@name:adapter 数据适配器-数据格式转换
   *@param:data {array|object} 数据对象 
   *@param:mapping {object} 数据映射表-对象形式
   *@description:data:[{a:[{c11:'xxx'}]}] mapping:{'a':'a[0].c11'}
   *@return:映射后的数据[{a:'xxx'}]
   *@author: zhengff
   *@date: 2019-05-02 18:28:12
  */
  adapter(data, mapping = {}, isNew = false) {

    if (!data || !mapping) {
      return
    }

    if (_.isArray(data)) {

      _.map(data, object => {
        let result = {};

        if (!isNew) {
          result = object
        }

        _.forIn(mapping, (value, key) => {
          result[key] = _.get(object, value);
        })

        return result;
      })
    } else if (_.isObject(data)) {

      let result = {};

      if (!isNew) {
        result = data
      }

      _.forIn(mapping, (value, key) => {
        result[key] = _.get(data, value);
      })

      return result;
    }

    return data;
  },
  getAllPath(data) {
    let resultArr = []
    if (undefined === data || null === data || !(data instanceof Object)) {
      return;
    }
    for (let item of data) {
      if (item.path) {
        resultArr.push(item.path);
      }
      if (null !== item.childrens && item.childrens instanceof Array) {
        for (let child of item.childrens) {
          if (child.path) {
            resultArr.push(child.path);
          }
          if (null !== child.childrens && child.childrens instanceof Array) {
            for (let leaf of child.childrens) {
              if (leaf.path) {
                resultArr.push(leaf.path);
              }
            }
          }
        }
      }
    }
    return resultArr
  }
}

export default DATA;